import React from 'react';

export const DealRing = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.01592 2.6501C5.82478 2.6501 4.04851 4.42637 4.04851 6.61751V11.2374H11.9833V6.61751C11.9833 4.42637 10.2071 2.6501 8.01592 2.6501ZM2.74851 6.61751V11.2374H2.43223C2.07324 11.2374 1.78223 11.5284 1.78223 11.8874C1.78223 12.2464 2.07324 12.5374 2.43223 12.5374H5.87925C5.88319 13.7141 6.8383 14.6668 8.01591 14.6668C9.19353 14.6668 10.1486 13.7141 10.1526 12.5374H13.5676C13.9266 12.5374 14.2176 12.2464 14.2176 11.8874C14.2176 11.5284 13.9266 11.2374 13.5676 11.2374H13.2833V6.61751C13.2833 3.7084 10.925 1.3501 8.01592 1.3501C5.10681 1.3501 2.74851 3.7084 2.74851 6.61751ZM8.85256 12.5374H7.17927C7.18319 12.9961 7.55627 13.3668 8.01591 13.3668C8.47556 13.3668 8.84864 12.9961 8.85256 12.5374Z"
      fill="#30259B"
    />
  </svg>
);
